<template>
  <CourierRecoveryComponent />
</template>
<script lang="ts">
import CourierRecoveryComponent from "@/components/courier/CourierRecovery.vue";
import { defineComponent, onBeforeMount } from "vue";
import { FLAGS } from "@/define";
import { useRouter } from "vue-router";
const componentName = "CourierRecoveryRoute";
export default defineComponent({
  name: componentName,
  components: {
    CourierRecoveryComponent,
  },
  props: {
    activationCodeToInstall: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      if (FLAGS.ENABLE_VD_COURIER_RECOVERY === "false") router.push("/home");
    });
  },
});
</script>
